import {
	registerResourcePlugin,
	validateResourcePlugins,
} from '../core/resourcePluginRegistry';

/**
 * Discover resource plugins through the frontend bundler.
 * @return {Array<object>} discovered plugins
 */
export function discoverResourcePlugins() {
	const modules = require.context('./', true, /plugin\.js$/);
	return modules.keys()
		.sort()
		.map((path) => modules(path).default)
		.filter(Boolean);
}

/**
 * Register and validate a deterministic plugin set.
 * @param {Array<object>} plugins resource plugins
 * @return {Function} unregister callback
 */
export function registerResourcePluginSet(plugins) {
	const unregister = [...plugins]
		.sort((left, right) => left.id.localeCompare(right.id))
		.map(registerResourcePlugin);
	try {
		validateResourcePlugins();
	} catch (error) {
		unregister.reverse().forEach((remove) => remove());
		throw error;
	}
	return () => unregister.reverse().forEach((remove) => remove());
}

/**
 * Register every plugin shipped in this Canvas build.
 * @return {Function} unregister callback
 */
export function registerBuiltInResourcePlugins() {
	return registerResourcePluginSet(discoverResourcePlugins());
}
